// Two-window split-ratio model (TODO §4.7). Pure values/helpers, kept out of the
// SplitResizer component file so that stays a component-only module (fast-refresh clean).

// Split ratio bounds (the first window's fraction). MIN/MAX leave headroom past the
// 1/4 and 3/4 presets so those are comfortably reachable by drag; DEFAULT is an even
// split when a slide has no stored ratio.
export const MIN_SPLIT = 0.2;
export const MAX_SPLIT = 0.8;
export const DEFAULT_SPLIT = 0.5;

export const clampSplit = (n: number) =>
  Math.min(MAX_SPLIT, Math.max(MIN_SPLIT, n));

// Discrete ratio presets (the first window's exact fraction) so a whole deck can share
// pixel-perfect splits without hand-dragging each slide. Values are exact so
// re-selecting the same preset across slides yields identical proportions.
export const RATIO_PRESETS: { label: string; value: number }[] = [
  { label: "1/4", value: 1 / 4 },
  { label: "1/3", value: 1 / 3 },
  { label: "1/2", value: 1 / 2 },
  { label: "2/3", value: 2 / 3 },
  { label: "3/4", value: 3 / 4 },
];

// The preset whose fraction matches `ratio` (within a subpixel tolerance), or undefined
// when the ratio came from a free drag between presets.
export function activePresetLabel(ratio: number): string | undefined {
  return RATIO_PRESETS.find((p) => Math.abs(p.value - ratio) < 0.005)?.label;
}
